const StaticEntity = ({img}: {img?: string}): JSX.Element => (
  <img src={img} alt='' className='tileimg' />
)

export default StaticEntity